import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/advanced/screen7.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/AdvancedAnalytics/index.tsx");
